import React from "react";
import { ImpactFindingsTable } from "@/components/molecules/salesforce-release/ImpactFindingsTable";
import type { ComponentImproveArg } from "@/components/atoms/salesforce-release/ComponentRow";
import type { FindingOut, ReleaseDocument } from "@/services/salesforce-release";

interface Props {
  findings: FindingOut[];
  isLoading?: boolean;
  componentTypes: string[];
  searchTerm: string;
  selectedBucket: string;
  selectedType: string;
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalComponents: number;
  totalFindings: number;
  onSearchChange: (v: string) => void;
  onBucketChange: (v: string) => void;
  onTypeChange: (v: string) => void;
  onPageChange: (n: number) => void;
  onPageSizeChange: (n: number) => void;
  docs?: ReleaseDocument[];
  activeReleaseId?: string | null;
  onPickDoc?: (id: string) => void;
  liveStatusLabel?: string | null;
  liveStatusPct?: number | null;
  liveStatusError?: string | null;
  onImproveWithAI?: () => void;
  canImprove?: boolean;
  onImproveComponent?: (group: ComponentImproveArg) => void;
}

/** Thin orchestrator mirroring SecurityScannerContent. */
export const ReleaseImpactContent: React.FC<Props> = (props) => {
  return (
    <div className="h-full">
      <ImpactFindingsTable {...props} />
    </div>
  );
};

export default ReleaseImpactContent;
